import React from 'react';

const AddIcon = ({ fill }: { fill: string }) => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 6.75C12.3125 6.75 11.75 7.3125 11.75 8V11.75H8C7.3125 11.75 6.75 12.3125 6.75 13C6.75 13.6875 7.3125 14.25 8 14.25H11.75V18C11.75 18.6875 12.3125 19.25 13 19.25C13.6875 19.25 14.25 18.6875 14.25 18V14.25H18C18.6875 14.25 19.25 13.6875 19.25 13C19.25 12.3125 18.6875 11.75 18 11.75H14.25V8C14.25 7.3125 13.6875 6.75 13 6.75ZM13 0.5C6.1 0.5 0.5 6.1 0.5 13C0.5 19.9 6.1 25.5 13 25.5C19.9 25.5 25.5 19.9 25.5 13C25.5 6.1 19.9 0.5 13 0.5ZM13 23C7.4875 23 3 18.5125 3 13C3 7.4875 7.4875 3 13 3C18.5125 3 23 7.4875 23 13C23 18.5125 18.5125 23 13 23Z"
      fill={fill}
    />
  </svg>
);

export default AddIcon;
